import React, { useContext } from 'react';
import proptypes from 'prop-types';
const { string } = proptypes;
import { ProductListContext } from '../ProductListContext';

export const ProductNote = ({ itemId }) => {
  const {
    list
  } = useContext(ProductListContext);

  // Find the item with comments in the new data structure
  let currentProduct = null;

  // Search through all groups to find the item
  if (list?.groups) {
    currentProduct = list.groups
      .filter((group) => group.items)
      .map((group) => group.items.find((item) => item.itemId === itemId))
      .find((item) => item) || null;
  }

  // If no comments exist, don't render anything
  if (!currentProduct?.comments) {
    return null;
  }

  return (
    <div data-testid={`product-note-${itemId}`} className="sui-p-4 sui-bg-subtle">
      <p>{currentProduct.comments}</p>
    </div>
  );
};

ProductNote.displayName = 'ProductListProductNote';

ProductNote.propTypes = {
  itemId: string.isRequired
};
